export default "__VITE_ASSET__DESXZaki__"